import { NWGJobState } from "@/core/models/nwg-job";

export default {
  getJobList: (state: NWGJobState) => state.jobList,
  getJobDetails: (state: NWGJobState) => state.jobDetails,
  getBatchDetails: (state: NWGJobState) => state.batchDetails,
  getBatchList: (state: NWGJobState) => state.batchList,
};
